import { BaseTemplate } from "@/components/shared/UniversalEntityPage/types";
import { TaskTemplate } from "@/lib/types/task-templates";
import { TicketTemplate } from "@/lib/types/database";

/**
 * Extract form values from any template type
 * Handles property name differences internally
 */
export function extractTemplateFormValues(template: BaseTemplate): Record<string, unknown> {
  const values: Record<string, unknown> = {};

  // Standard properties (always available)
  if (template.title) values.title = template.title;
  if (template.description_text) values.description = template.description_text;
  if (template.tags) values.tags = template.tags;

  // Optional properties
  if ("priority" in template && template.priority) values.priority = template.priority;
  if ("status" in template && template.status) values.status = template.status;
  if ("estimated_hours" in template && template.estimated_hours !== undefined) {
    values.estimated_hours = template.estimated_hours;
  }
  if ("sla_hours" in template && template.sla_hours !== undefined) {
    values.sla_hours = template.sla_hours;
  }

  return values;
}

/**
 * Ensure a TicketTemplate satisfies BaseTemplate by mapping description_template to description_text
 * This is a helper for cases where we need to convert TicketTemplate to BaseTemplate-compatible format
 * Creates a new object that satisfies BaseTemplate interface
 */
export function ensureTicketTemplateBaseCompatibility(template: TicketTemplate): BaseTemplate {
  return {
    id: template.id,
    name: template.name,
    description: template.description,
    category: template.category,
    title: template.title_template || template.title || "",
    description_text: template.description_template || template.description || "",
    tags: template.tags,
    estimated_hours: template.estimated_hours,
    sla_hours: template.sla_hours,
  };
}
